type Kind = "w" | "t" | "b" | "f" | "j"
type Rank = 1|2|3|4|5|6|7|8|9

export type Tile =
{
    kind: Kind,
    rank: Rank,
}

export function fromIndex(index: number): Tile
{
    if (index < 0 || 34 <= index || !Number.isInteger(index))
        throw new Error(`invalid input: ${index}`)
    if (index < 9)
        return {kind: "w", rank: (index+1) as Rank}
    if (index < 18)
        return {kind: "t", rank: (index-8) as Rank}
    if (index < 27)
        return {kind: "b", rank: (index-17) as Rank}
    if (index < 31)
        return {kind: "f", rank: (index-26) as Rank}
    if (index < 34)
        return {kind: "j", rank: (index-30) as Rank}
    throw new Error("unreachable")
}

export function toIndex({kind, rank}: Tile): number
{
    switch (kind)
    {
        case "w":
            return rank-1
        case "t":
            return rank+8
        case "b":
            return rank+17
        case "f":
            return rank+26
        case "j":
            return rank+30
    }
}